export default __webpack_public_path__ + "static/media/back.b2d76d57.svg";